// Scroll to section on page load if hash is present in URL
// Wrapped in try-catch to prevent errors from blocking execution
(function() {
  'use strict';
  
  console.log('Bundle scroll script loaded');
  
  function scrollToSection() {
    try {
      console.log('scrollToSection called, hash:', window.location.hash);
      
      // Check if there's a hash in the URL
      if (!window.location.hash) {
        console.log('No hash in URL');
        return;
      }
      
      const hash = window.location.hash.substring(1); // Remove the # symbol
      if (!hash) {
        console.log('Empty hash');
        return;
      }
      
      console.log('Looking for element with hash:', hash);
      
      // Try to find element by the exact hash ID first
      let targetElement = document.getElementById(hash);
      console.log('Direct ID lookup result:', targetElement);
      
      // If not found, try multiple strategies
      if (!targetElement) {
        // Strategy 1: Try exact hash match with querySelector (escape special chars)
        try {
          // Escape CSS selector special characters
          const escapedHash = hash.replace(/([!"#$%&'()*+,.\/:;<=>?@[\\\]^`{|}~])/g, '\\$1');
          targetElement = document.querySelector('#' + escapedHash);
          console.log('QuerySelector with escaped hash result:', targetElement);
        } catch (e) {
          console.log('QuerySelector failed:', e);
        }
        
        // Strategy 2: Try finding elements that start with shopify-section (most likely)
        if (!targetElement) {
          try {
            const allSections = document.querySelectorAll('[id^="shopify-section-"]');
            console.log('Found sections with shopify-section prefix:', allSections.length);
            allSections.forEach(section => {
              if (section && section.id) {
                console.log('Checking section ID:', section.id, 'against hash:', hash);
                // Check for exact match or if hash contains section ID or vice versa
                if (section.id === hash || 
                    section.id.includes(hash) || 
                    hash.includes(section.id) ||
                    section.id.endsWith(hash.split('__').pop())) {
                  console.log('Matched section:', section.id);
                  targetElement = section;
                }
              }
            });
          } catch (e) {
            console.log('Section search failed:', e);
          }
        }
        
        // Strategy 3: Try finding by partial match (fallback)
        if (!targetElement) {
          try {
            const allElements = document.querySelectorAll('[id]');
            console.log('Total elements with IDs:', allElements.length);
            for (let i = 0; i < allElements.length; i++) {
              const el = allElements[i];
              if (el.id && (el.id === hash || el.id.includes(hash) || hash.includes(el.id))) {
                console.log('Found partial match:', el.id);
                targetElement = el;
                break;
              }
            }
          } catch (e) {
            console.log('Partial match search failed:', e);
          }
        }
      }
      
      if (targetElement) {
        console.log('Target element found:', targetElement.id || targetElement.className);
        // Wait a bit for page to be fully rendered
        setTimeout(function() {
          try {
            console.log('Attempting to scroll to element');
            const rect = targetElement.getBoundingClientRect();
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const targetPosition = rect.top + scrollTop - 100; // 100px offset for header
            
            window.scrollTo({
              top: targetPosition,
              behavior: 'smooth'
            });
            console.log('Scroll initiated to position:', targetPosition);
          } catch (e) {
            console.log('Error scrolling:', e);
            // Fallback to instant scroll
            try {
              targetElement.scrollIntoView();
              window.scrollBy(0, -100);
              console.log('Fallback scroll executed');
            } catch (e2) {
              console.log('Fallback scroll also failed:', e2);
            }
          }
        }, 1000); // Increased delay to ensure page is fully loaded
      } else {
        console.log('Could not find element with hash:', hash);
        console.log('Available IDs on page:', Array.from(document.querySelectorAll('[id]')).map(el => el.id).slice(0, 20));
        // Try one more time after a longer delay
        setTimeout(function() {
          console.log('Retrying to find element...');
          const retryElement = document.getElementById(hash) || document.querySelector('#' + hash);
          if (retryElement) {
            console.log('Found element on retry');
            const rect = retryElement.getBoundingClientRect();
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const targetPosition = rect.top + scrollTop - 100;
            window.scrollTo({
              top: targetPosition,
              behavior: 'smooth'
            });
          } else {
            console.log('Still could not find element after retry');
          }
        }, 3000);
      }
    } catch (error) {
      console.error('Error in scrollToSection:', error);
    }
  }
  
  // Run on page load (with delay to ensure DOM is ready)
  function initScroll() {
    try {
      console.log('Initializing scroll, readyState:', document.readyState);
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
          console.log('DOMContentLoaded fired');
          setTimeout(scrollToSection, 1000);
        });
      } else {
        // DOM already loaded, but wait a bit more for dynamic content
        console.log('DOM already loaded, scheduling scroll');
        setTimeout(scrollToSection, 1000);
      }
      
      // Also handle hash changes (in case user navigates with hash)
      window.addEventListener('hashchange', function() {
        console.log('Hash changed');
        setTimeout(scrollToSection, 100);
      });
    } catch (error) {
      console.error('Error initializing scroll:', error);
    }
  }
  
  // Start initialization
  initScroll();
})();

